import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APIGiaoDichVien = {
  LIST_GIAO_DICH_VIEN: `${BASE_API_URL_CAP_DIEN}/giao-dich-vien/list`,
  CREATE_GIAO_DICH_VIEN: `${BASE_API_URL_CAP_DIEN}/giao-dich-vien/create`,
  UPDATE_GIAO_DICH_VIEN: `${BASE_API_URL_CAP_DIEN}/giao-dich-vien/update`,
  REMOVE_GIAO_DICH_VIEN: `${BASE_API_URL_CAP_DIEN}/giao-dich-vien/delete`,
};
